import axios from 'axios'
import { UrlBase } from './config'

const companies = {}

companies.createCompany = async (token, data) => {
  try {
    const { name, phone, email, address, url } = data

    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies',
      data: { name, phone, email, address, url }
    }

    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

companies.getCompany = (token, uuid) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + uuid
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

companies.getCompanies = async token => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies',
      params: {
        getApps: true,
        limit: 2000
      }
    }

    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

companies.getAdministrators = async (token, companyId, search, pagination) => {
  if (!pagination || typeof pagination !== 'object' || Object.keys(pagination).length === 0) {
    pagination = {
      page: 1,
      itemsPerPage: 300,
      sortBy: [],
      sortDesc: []
    }
  }
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy[0],
        descending: pagination.sortDesc[0],
        limit: pagination.itemsPerPage,
        search
      },
      url: UrlBase + 'administrator/companies/' + companyId
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

companies.getAdministrator = async (token, companyId, administratorId) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        filName: 'UUID',
        filValue: administratorId
      },
      url: UrlBase + 'administrator/companies/' + companyId
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

companies.newAdministrator = async (token, companyId, data) => {
  const { name, lastName, email, userType, phone, password, rolId, inactive, sendEmail, country, countryCode, tags } = data
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: {
        name,
        lastName,
        email,
        userType,
        country,
        countryCode,
        phone,
        password,
        rolId,
        inactive,
        sendEmail,
        tags
      },
      url: UrlBase + 'administrator/companies/' + companyId
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

companies.updateAdministrator = async (token, companyId, data) => {
  try {
    const { administratorId, name, lastName, email, userType, phone, rolId, inactive, sendEmail, country, countryCode, tags, photo } = data
    const request = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: {
        name,
        lastName,
        email,
        userType,
        country,
        countryCode,
        phone,
        rolId,
        inactive,
        sendEmail,
        tags,
        photo
      },
      url: UrlBase + 'administrator/companies/' + companyId + '/userId/' + administratorId
    }
    const response = await axios(request)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

companies.inviteAdministrator = async (token, companyId, users) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/invite',
      data: {
        invitations: users
      }
    }

    const response = await axios(request)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

companies.removeAdministrator = async (token, companyId, userId) => {
  try {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'administrator/companies/' + companyId + '/userId/' + userId
    }
    return await axios(request)
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

companies.updateCompany = (token, companyId, { name, phone, email, address, url }) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId,
      data: { name, phone, email, address, url }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

companies.getAllPermissions = async (token) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'admin/roles'
    }
    return axios(request)
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

export default companies
